/**
 * TabPicker Zustand Stores Index
 * 
 * Central export point for all Zustand stores in the TabPicker application.
 * Provides a clean interface for importing stores and related utilities.
 * 
 * @module TabPicker.Stores
 */

// Import stores for utility functions
import { useAuthStore } from './authStore';
import { useGameStore } from './gameStore';
import { useLocationStore } from './locationStore';

// Authentication store exports
export {
  useAuthStore,
  authSelectors,
  useCurrentUser,
  useIsAuthenticated,
  useAuthLoading,
  useAuthActions,
  type User,
  type AuthStore,
} from './authStore';

// Game store exports  
export {
  useGameStore,
  gameSelectors,
  usePayoutRows,
  useGameConfig,
  useHasUnsavedChanges,
  useGameToast,
  useImportState,
  type PayoutRow,
  type GameConfig,
  type GameStore,
} from './gameStore';

// Location store exports
export {
  useLocationStore,
  locationSelectors,
  useLocationPreferences,
  useCurrentLocation,
  useIsLocationAvailable,
  useLocationSharingEnabled,
  useHasLocationPermission,
  useIsRequestingLocation,
  useMaxDiscoveryRadius,
  useLocationActions,
  type LocationPreferences,
  type UserLocation,
  type LocationStore,
} from './locationStore';

/**
 * Store initialization utilities
 */
export const initializeStores = () => {
  // Initialize auth store
  const authStoreState = useAuthStore.getState();
  authStoreState.initialize();
  
  // Initialize location store
  const locationStoreState = useLocationStore.getState();
  locationStoreState.initialize();
  
  // Any other store initialization logic can go here
};

/**
 * Reset all stores (useful for testing or logout)
 */
export const resetAllStores = () => {
  const authStoreState = useAuthStore.getState();
  const gameStoreState = useGameStore.getState();
  const locationStoreState = useLocationStore.getState();
  
  authStoreState.reset();
  gameStoreState.resetGame();
  locationStoreState.reset();
};